import {Injectable} from '@angular/core';
import {ToastController, ToastOptions} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastProvider {
  public toast: HTMLIonToastElement;

  constructor(
    private toastController: ToastController) {
  }

  async createToast(options: Partial<ToastOptions>) {
    this.toast = await this.toastController.create({
      ...options,
    });
  }

  async presentToast(options: Partial<ToastOptions>) {
    await this.createToast({...options,
      duration: 4000,
      position: 'top',});
    await this.toast.present();
  }

}
